import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
export function HeroSection() {
  const lineVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.8,
        duration: 1,
        ease: 'easeOut'
      }
    })
  };
  return <div className="min-h-screen flex flex-col justify-center pt-16 pb-20" data-id="element-60">
      <Section className="!py-0" data-id="element-61">
        <motion.h1 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.5
      }} className="text-6xl md:text-8xl font-serif font-bold text-[#faf6f0] mb-6 tracking-tight text-center" data-id="element-62">
          It's 2:13am.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 1,
        ease: 'easeOut'
      }} className="text-center space-y-1.5 mb-10 max-w-md mx-auto" data-id="element-63">
          <p className="text-lg md:text-xl text-[#f5f0e8] leading-snug font-light" data-id="element-64">
            Your baby is finally asleep… in your arms.
          </p>
          <p className="text-lg md:text-xl text-[#f5f0e8] leading-snug font-light" data-id="element-65">
            You tell yourself,{' '}
            <span className="italic text-[#b8a9c9]" data-id="element-66">
              "Okay. This time I'll do it perfectly."
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 1,
        ease: 'easeOut'
      }} className="flex justify-center mb-10" data-id="element-67">
          <div className="relative" data-id="element-68">
            <div className="absolute -inset-4 bg-[#c9a96e] opacity-[0.07] blur-3xl rounded-full" data-id="element-69"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9Bq7sPCfAAwFiYxEkykq9Q/heylloyd-image-1771111670446.png" alt="Baby Only Sleeps In My Arms — Emergency Night Protocol ebook on tablet" className="relative w-80 md:w-[32rem] rounded-lg shadow-[0_20px_60px_rgba(201,169,110,0.15)]" data-id="element-70" />
          </div>
        </motion.div>

        <div className="space-y-6 text-xl md:text-2xl text-[#f5f0e8] leading-relaxed font-light" data-id="element-71">
          <motion.p custom={1} variants={lineVariants} initial="hidden" animate="visible" data-id="element-72">
            You stand up slowly. You step to the bassinet like you're defusing a
            bomb.
          </motion.p>

          <motion.p custom={2} variants={lineVariants} initial="hidden" animate="visible" data-id="element-73">
            And the second your baby touches the mattress—
          </motion.p>

          <motion.p custom={3} variants={lineVariants} initial="hidden" animate="visible" className="font-medium text-[#c97a7a]" data-id="element-74">
            Eyes snap open. Body stiffens. The cry hits like a siren.
          </motion.p>

          <motion.p custom={4} variants={lineVariants} initial="hidden" animate="visible" data-id="element-75">
            So you do what you swore you wouldn't do:
          </motion.p>

          <motion.p custom={5} variants={lineVariants} initial="hidden" animate="visible" className="border-l-4 border-[#b8a9c9] pl-6 py-2 text-[#d4cfc5] italic" data-id="element-76">
            You sit back down and hold them again… because you're terrified
            you'll fall asleep standing up.
          </motion.p>

          <motion.div custom={6} variants={lineVariants} initial="hidden" animate="visible" className="pt-6" data-id="element-77">
            <p className="font-serif text-2xl md:text-3xl text-[#faf6f0]" data-id="element-78">
              If you're living this loop, you don't need another "try white
              noise" post.
            </p>
            <p className="mt-4 font-serif text-2xl md:text-3xl text-[#c9a96e] font-bold" data-id="element-79">
              You need a night protocol you can run when your brain is fried.
            </p>
          </motion.div>

          <motion.div custom={7} variants={lineVariants} initial="hidden" animate="visible" className="pt-10 flex justify-center" data-id="element-80">
            <div className="relative group" data-id="element-81">
              <div className="absolute -inset-4 bg-[#c9a96e] opacity-[0.07] blur-3xl rounded-full" data-id="element-82"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9Bq7sPCfAAwFiYxEkykq9Q/heylloyd-image-1771111670446.png" alt="Baby Only Sleeps In My Arms — Emergency Night Protocol ebook on tablet" className="relative w-64 md:w-80 rounded-lg shadow-[0_20px_60px_rgba(201,169,110,0.15)]" data-id="element-83" />
            </div>
          </motion.div>
        </div>
      </Section>
    </div>;
}